_BannerFlowApp.directive("bfActionButton", function ($timeout) {
    return {
        restrict: "E",
        replace: true,
        transclude: true,
        scope: {
            callback: "&?"
        },
        template: '<div class="bf-action-button">' + "<ng-transclude></ng-transclude>" + "</div>",
        link: function (scope, element, attrs, ngModel) {
            var keyDownEvent = null;
            var menu = $(".bf-action-menu", element).first();
            var button = $(".bf-button", element).first();
            var isOpen = false;

            var close = function () {
                isOpen = false;
                menu.hide();
                button.toggleClass("bf-button--active", false);

                if (keyDownEvent) $(window).off("keydown", keyDownEvent);
            };

            button.click(function (ev) {
                if (isOpen) {
                    $(window).off("mousedown");
                    close();
                    return;
                }

                menu.show();
                menu.find("input").first().focus();

                button.toggleClass("bf-button--active", true);

                $timeout(function () {
                    if (scope.callback) scope.callback();
                });

                $(window).on("mousedown", function (e) {
                    if (
                        !$(e.target).is(button) &&
                        !$.contains(button[0], e.target) &&
                        !$(e.target).is(".bf-action-menu") &&
                        !$(e.target).parents(".bf-action-menu").size() &&
                        !$(e.target).is(".ngdialog") &&
                        !$(e.target).parents(".ngdialog").size()
                    ) {
                        $(window).off("mousedown");
                        close();
                    }
                });

                keyDownEvent = function (e) {
                    if (e.keyCode === 27) close();
                };

                $(window).on("keydown", keyDownEvent);

                isOpen = true;
            });

            menu.hide();
        }
    };
});
